import { Component } from '@angular/core';
import { ActionButtonsComponent } from '../../../components/action-buttons/action-buttons.component';
import { ValueAnalysisComponent as SharedValueAnalysisComponent } from '../../../components/value-analysis/value-analysis.component';
import { SpacesService } from '../../../services/spaces.service';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-value-analysis-page',
  standalone: true,
  imports: [SharedValueAnalysisComponent, ActionButtonsComponent],
  templateUrl: './value-analysis.component.html',
  styleUrl: './value-analysis.component.scss'
})
export class ValueAnalysisComponent {
  constructor(
    private readonly spacesService: SpacesService,
    private readonly modalService: ModalService
  ) {}

  resetAll(): void {
    this.spacesService.clearActiveSpace();
  }

  openSaveToSpaces(): void {
    this.modalService.openCreateSpaceModal(this.spacesService.getActiveSpace());
  }
}
